import Head from './../components/Head';
import TeacherCard from './components/teacherCard.vue';
import Footer from '../components/Footer.vue';
import LeftMenuItem from '../components/LeftMenuItem.vue';
import { Empty } from 'zhs-components';
import { teacherTab } from './components/data';
import FirstClass from './components/firstClass.vue';
import ExcellentVideo from '../components/excellentVideo.vue';
import CourseList from '../courseList/App.vue';
import CommonTopTitle from '../components/CommonTopTitle.vue';
export default {
  async created() {
    this.menuId = this.$utils.getUrlParams('menuId');
    this.menuName = this.$utils.getUrlParams('name');
    await this.queryGetPortal_homepage();
    await this.getTeacherSet();
    await this.getMenuData();
    await this.getTeacherList();
  },

  components: {
    Head,
    TeacherCard,
    Footer,
    Empty,
    LeftMenuItem,
    FirstClass,
    ExcellentVideo,
    CourseList,
    CommonTopTitle
  },

  data() {
    return {
      menuId: '',
      menuName: '',
      menuIdKey: '',
      courseName: '',
      courseNameMathRandom: 0,
      currentCategoryId: -1,
      dialogTeacherVisible: false,
      currentTeacher: {},
      pageInfo: {
        pageIndex: 1,
        rows: 0,
        pageLimit: 9,
        pageLimit2: 45
      },
      tabIndex: 0,
      teacherList: [],
      teacherTabList: teacherTab,
      menuData: [],
      searchInfo: {
        userName: '',
        collegeId: '',
        collegeName: '',
        titleId: '',
        titleName: ''
      },
      showMoreTeacherTitle: false,
      // 是否显示更多教师称号
      showMoreCollege: false,
      // 是否显示更多学院
      organ_flag: '',
      showType: '',
      sort: '',
      navHomePageList: [],
      inputNav: {
        0: '搜索教师名称',
        1: '搜索课程名称',
        2: '搜索课程名称',
        3: '搜索视频名称'
      }
    };
  },

  watch: {
    searchInfo: {
      handler(value) {
        this.pageInfo.pageIndex = 1;
        this.getTeacherList();
      },

      deep: true
    },
    showType: {
      handler(val) {
        this.getTeacherList();
      },

      deep: true
    },
    courseName: {
      handler(val) {
        if (this.tabIndex === 0) {
          this.getTeacherList();
        }
      },

      deep: true
    }
  },
  methods: {
    async handleTabIndex(item, index) {
      this.tabIndex = index;
      this.menuIdKey = item.menu_id;
      this.courseName = ''; //  更新地址栏携带参数，但不刷新页面

      history.pushState('', '', `/teacherList.html?menuId=${this.menuId}&name=${this.menuName}&tab=${this.menuIdKey}`);

      if (this.tabIndex == 0) {
        await this.getTeacherSet();
        await this.getMenuData();
        await this.getTeacherList();
      }
    },

    //搜索
    handleSearch() {// this.pageInfo.pageIndex = 1
      // this.getCourseList()
    },

    //获取导航tab切换
    async queryGetPortal_homepage() {
      const res = await this.$http.getPortal_homepage({
        parent_menu_id: this.$utils.getUrlParams('menuId')
      });
      this.navHomePageList = res;

      if (this.$utils.getUrlParams('tab')) {
        this.menuIdKey = this.$utils.getUrlParams('tab');
        this.tabIndex = res.findIndex(item => item.menu_id === this.menuIdKey);
      } else {
        this.menuIdKey = res[0].menu_id;
      }
    },

    //获取左侧筛选项(menuData) getPortal_homepage
    async getMenuData() {
      const params = {
        menu_id: this.menuIdKey
      };
      const res = await Promise.all([this.$http.getTeacherTitle(params), this.$http.getTeacherCollege(params)]);
      let sum1 = res[0].reduce((total, item) => {
        return total + parseInt(item.count);
      }, 0);
      let sum2 = res[1].reduce((total, item) => {
        return total + parseInt(item.count);
      }, 0);
      const obj1 = {
        title: '荣誉称号',
        icon: require('@/assets/images/menu-icon-1.png'),
        content: [{
          id: '',
          name: '全部',
          count: sum1
        }, ...res[0].map(item => {
          return {
            id: item.honorary_title_id,
            name: item.honorary_title_name,
            count: item.count
          };
        })]
      };
      const obj2 = {
        title: '归属学院',
        icon: require('@/assets/images/menu-icon-2.png'),
        content: [{
          id: '',
          name: '全部',
          count: sum2
        }, ...res[1].map(item => {
          return {
            id: item.organ_id,
            name: item.organ_name,
            count: item.count
          };
        })]
      };
      this.menuData = [obj1, obj2];
    },

    // 获取教师列表
    async getTeacherList() {
      const teacherList = await this.$http.getTeacherList({
        '_pageable.size': this.showType == 1 ? this.pageInfo.pageLimit : this.pageInfo.pageLimit2,
        '_pageable.page': this.pageInfo.pageIndex - 1,
        menu_id: this.menuIdKey,
        teacher_name: this.courseName || undefined,
        honorary_title_id: this.searchInfo.titleId || undefined,
        organ_id: this.searchInfo.collegeId || undefined,
        sort_type: this.sort || undefined
      }); //   console.log('名师列表', teacherList)

      this.teacherList = teacherList.content || [];
      this.pageInfo.rows = +teacherList.totalElements || 0;
    },

    handleChangePageSize(pageSize) {
      this.pageInfo.pageLimit = pageSize;
      this.pageInfo.pageIndex = 1;
      this.searchInfo.titleId = '';
      this.searchInfo.collegeId = '';
      this.searchInfo.userName = '';
      this.getTeacherList();
    },

    handleSearch() {
      this.courseNameMathRandom = Math.random();
      this.pageInfo.pageIndex = 1;

      if (this.tabIndex == 0) {
        this.getTeacherList();
      }
    },

    // 清空选中
    clearSelected(index) {
      if (index === 1) {
        this.searchInfo.titleId = '';
      } else if (index === 2) {
        this.searchInfo.collegeId = '';
      }

      this.pageInfo.pageIndex = 1;
    },

    // 切换称号显示
    toggleShowTeacherTitle() {
      this.showMoreTeacherTitle = !this.showMoreTeacherTitle;
    },

    // 切换称号
    teacherTitleChange(item) {
      this.searchInfo.titleId = item.id;
      this.searchInfo.titleName = item.name;
      this.pageInfo.pageIndex = 1; // this.getTeacherList();
    },

    // 切换学院显示
    toggleShowCollege() {
      this.showMoreCollege = !this.showMoreCollege;
    },

    // 切换学院
    collegeChange(item) {
      this.searchInfo.collegeId = item.id;
      this.searchInfo.collegeName = item.name;
      this.pageInfo.pageIndex = 1;
    },

    // 切换分页
    pageIndexChange(current) {
      this.pageInfo.pageIndex = current;
      this.getTeacherList();
    },

    // 获取高级设置
    async getTeacherSet() {
      const res = await this.$http.getTeacherSet({
        menu_id: this.menuIdKey
      });
      res.forEach(item => {
        if (item.code == 'teacher_filter') {
          this.organ_flag = item.code_value;
        }

        if (item.code == 'teacher_show_type') {
          this.showType = item.code_value;
        }

        if (item.code == 'teacher_sort') {
          this.sort = item.code_value;
        }
      }); //   console.log('师-设置', res)
    },

    goDetail(id) {
      window.location.href = `/teacherDetailInfo.html?id=${id}&name=${this.menuName}&menuId=${this.menuId}`;
    },

    showType1() {
      this.pageInfo.pageIndex = 1;
      this.showType = 1;
    },

    showType2() {
      this.pageInfo.pageIndex = 1;
      this.showType = 2;
    }

  }
};